import React from 'react';

export interface ScenePreset {
  id: string;
  label: string;
  emoji: string;
  prompt: string;
  style: string;
}

export const SCENE_PRESETS: ScenePreset[] = [
  {
    id: 'headshot',
    label: 'Professional Headshot',
    emoji: '💼',
    prompt: 'a professional corporate headshot of the character, waist-up, business attire, studio lighting, sharp focus, clean neutral background',
    style: 'Photographic (Default)',
  },
  {
    id: 'outdoor',
    label: 'Outdoor Portrait',
    emoji: '🌅',
    prompt: 'a full-body outdoor portrait of the character standing in a park, golden hour, soft natural light, casual modern outfit, depth of field',
    style: 'Photographic (Default)',
  },
  {
    id: 'beach',
    label: 'Beach',
    emoji: '🏖️',
    prompt: 'a full-body photo of the character walking barefoot along a tropical beach, palm trees, turquoise water, sunlit, vacation photography',
    style: 'Photographic (Default)',
  },
  {
    id: 'city',
    label: 'City Street',
    emoji: '🌆',
    prompt: 'a full-body cinematic photo of the character walking on a busy city street in the evening, shallow depth of field, urban lighting, stylish outerwear',
    style: 'Cinematic',
  },
  {
    id: 'formal',
    label: 'Formal Event',
    emoji: '🥂',
    prompt: 'a three-quarter length photo of the character at an elegant black-tie event, formal attire, chandelier lighting, shallow depth of field',
    style: 'Photographic (Default)',
  },
  {
    id: 'travel',
    label: 'Travel',
    emoji: '🗺️',
    prompt: 'a full-body travel photograph of the character exploring a European old town, cobblestone streets, historic architecture, daylight, casual travel outfit',
    style: 'Photographic (Default)',
  },
  {
    id: 'studio_fashion',
    label: 'Studio Fashion',
    emoji: '📸',
    prompt: 'a full-body studio fashion photograph of the character, seamless backdrop, high-key lighting, tasteful outfit, editorial composition',
    style: 'Photographic (Default)',
  },
  {
    id: 'outdoor_action',
    label: 'Outdoor Action',
    emoji: '🏞️',
    prompt: 'a full-body photograph of the character hiking on a mountain trail, natural light, outdoor gear, scenic landscape, dynamic pose',
    style: 'Photographic (Default)',
  },
];

interface ScenePresetsProps {
  selectedId: string | null;
  onSelect(preset: ScenePreset | null): void;
}

export default function ScenePresets({ selectedId, onSelect }: ScenePresetsProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {SCENE_PRESETS.map(preset => {
        const isSelected = selectedId === preset.id;
        return (
          <button
            key={preset.id}
            onClick={() => onSelect(isSelected ? null : preset)}
            className="flex flex-col items-center justify-center gap-1 py-3 px-2 rounded-lg transition-colors"
            style={{
              backgroundColor: isSelected
                ? 'color-mix(in srgb, var(--sage-primary) 15%, var(--sage-bg))'
                : 'var(--sage-bg)',
              border: isSelected
                ? '2px solid var(--sage-primary)'
                : '1px solid var(--sage-white-10)',
              color: 'var(--sage-text)',
            }}
          >
            <span className="text-xl leading-none">{preset.emoji}</span>
            <span className="text-xs text-center leading-tight">{preset.label}</span>
          </button>
        );
      })}
    </div>
  );
}
